import {
  Text,
  Flex,
  TextInput,
  type TextInputProps,
  type FlexProps,
} from '@mantine/core';
import baseClasses from './FormTextField.module.scss';
import type { Variant } from './FormTextField.type';

interface FormTextFieldProps extends TextInputProps {
  title: string;
  description: string;
  containerProps?: FlexProps;
  variant?: Variant;
}

export const FormTextField = ({
  title,
  description,
  placeholder,
  containerProps,
  variant = 'row',
  ...props
}: FormTextFieldProps) => {
  const styles = {
    formRow: variant === 'row' ? baseClasses.formRow : baseClasses.formColumn,
    leftColumn: variant === 'row' ? baseClasses.leftColumn : '',
    rightColumn:
      variant === 'row' ? baseClasses.rightColumn : baseClasses.input,
  };

  return (
    <Flex gap='24' className={styles.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={styles.leftColumn}>
        <Text className={baseClasses.title}>{title}</Text>
        <Text className={baseClasses.description}>{description}</Text>
      </Flex>
      <TextInput
        className={styles.rightColumn}
        variant='filled'
        placeholder={placeholder}
        {...props}
      />
    </Flex>
  );
};
